<div class="modal-body modal-max width-800" style="height:880px">
	<div class="layout-auto-1-auto">
		<span class="modal-header">Vorschau</span>
		<div class="content">
			<div class="layout-auto-1">
				<div class="grid cols-2">
					<div>
					</div>
					<div style="text-align: right">
						<button (click)="downloadDocument()" class="md-btn download-btn"><i
							class="far fa-2x fa-file-download"></i>
						</button>
					</div>
				</div>
				<div class="content pdf-viewer-box">
					<pdf-viewer class="host-pdf-view" style="display: block;"
					            [src]="url"
					            [render-text]="false"
					            [original-size]="true"
					            [fit-to-page]="true"
					            [show-borders]="true"
					            [show-all]="true"
					            (after-load-complete)="onLoaded($event)">
					</pdf-viewer>
					<div class="absolute-spinner fa-3x" *ngIf="uiStateShowLoading">
						<i class="fa-solid fa-spinner fa-spin-pulse" style="color:var(--c-dark-400);"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="spawn-modal-actions">
			<button (click)="close()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
		</div>
	</div>
</div>
